import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { PopinFormat } from '../../types';
import PopinBanner from './PopinBanner';
import PopinCentered from './PopinCentered';
import PopinClassic from './PopinClassic';
import PopinEdging from './PopinEdging';
import { PopinOptin } from './PopinOptin';
const Popins = ({ popins }) => {
    const renderPopin = popins.map((popin) => {
        switch (popin.format) {
            case PopinFormat.BANNER:
                return _jsx(PopinBanner, { popin: popin }, popin.id);
            case PopinFormat.POPIN:
                return _jsx(PopinClassic, { popin: popin }, popin.id);
            case PopinFormat.CENTERED:
                return _jsx(PopinCentered, { popin: popin }, popin.id);
            case PopinFormat.EDGING:
                return _jsx(PopinEdging, { popin: popin }, popin.id);
            case PopinFormat.OPTIN:
                return _jsx(PopinOptin, { popin: popin }, popin.id);
            case PopinFormat.OPTIN_CENTERED:
                return _jsx(PopinOptin, { popin: popin }, popin.id);
            default:
                return null;
        }
    });
    return _jsx(_Fragment, { children: renderPopin });
};
export default Popins;
